module.exports = __webpack_public_path__ + "static/media/challenges.e9ba785c.png";